export const environment = {
  authentication: {
    templatesMgtApiAuthScope: '#{DiflexmoAuth.FordeskScope}#',
    authFlow: '#{DiflexmoAuth.ApplicationRegistration.SignUpSignInPolicyId}#',

    redirectUrl: `${window.location.origin}`,
    tenant: '#{DiflexmoAuth.Tenant}#',
    authClientId: '#{DiflexmoAuth.ApplicationRegistration.UIClientId}#',

    postLogoutRedirectUri: `${window.location.origin}`,

    b2cDiflexmoTenantId: '#{DiflexmoAuth.ApplicationRegistration.B2CTenantId}#',
    b2cAppregistrationInstance: '#{DiflexmoAuth.ApplicationRegistration.Instance}#',
  },

  production: true,
  syncFusionLicenseKey: '#{SyncfusionAspNetCoreLicenseKey}#',
  apiHostUrl: '#{TemplateManagementUI.Api}#',
  fordeskUrl: '#{TemplateManagementUI.FordeskUrl}#',
};
